import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import AdventuresSlider from './AdventuresSlider'
import API from 'api'
import './styles/conservation-categories.scss'
import { FormattedMessage } from 'react-intl'
import { getProductCategory } from '../dive-guides/gtm-events'
import { convertCurrency } from '../helpers/PriceConverter'
import { setBrandValue } from '../../gtm'

export default function ConservationCategories({ categories = [{}] }) {
  const [activeCategory, setActiveCategory] = useState(categories[0].id)
  const [isLoading, setLoading] = useState(true)
  const [activites, setActivities] = useState([])

  const handleClick = (id) => () => setActiveCategory(id)

  useEffect(() => {
    let controller
    let signal

    setLoading(true)

    if('AbortController' in window) {
      controller = new window.AbortController()
      signal = controller.signal
    }

    API('/api/adventure/v1/search/location/all/conservation/', signal)
      .get({
        categories: activeCategory,
        page_size: 30,
      })
      .then(({ results }) => {
        results.forEach((product) => {
          const { type } = getProductCategory(50)
          const { currency, price } = product.price
          const { diveCenter } = product
          product.viewItem = {
            item_name: product.titleEn || product.title,
            item_id: product.activityId,
            price: convertCurrency(
              price,
              currency,
              window.currency,
              false,
              true,
            ).toFixed(2),
            item_brand: setBrandValue(diveCenter),
            item_category1: 'PADI Travel',
            item_category2: type,
            item_list_name: 'Travel Adventures - Conservation Activity Landing Page - By Category',
          }
        })
        setActivities(results)
        setLoading(false)
      })

    return () => controller && controller.abort()
  }, [activeCategory])

  return (
    <div className='conservation-categories'>
      <div className='conservation-categories__filters'>
        {categories.map((item) => (
          <div
            onClick={handleClick(item.id)}
            className={`conservation-categories__filter-item ${
              activeCategory === item.id
                ? 'conservation-categories__filter-item--active'
                : ''
            }`}
          >
            {item.title}
          </div>
        ))}
      </div>
      <div className='conservation-categories__list'>
        {!isLoading && !activites.length ? (
          <div className='no-results'>
            <FormattedMessage
              id='no-conservation'
              defaultMessage='No conservation activities here!'
            />
          </div>
        ) : (
          <AdventuresSlider
            items={activites}
            isLoading={isLoading}
            isConservation
          />
        )}
      </div>
    </div>
  )
}

ConservationCategories.propTypes = {
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      title: PropTypes.string.isRequired,
    }),
  ).isRequired,
}
